import { useState } from "react";
import SEO from "components/SEO";
import Button from "components/Inputs/Button";

const Delete = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const notify = (message, type = "info") => {
    if (type === "success") {
      alert("✅ " + message);
    } else if (type === "error") {
      alert("❌ " + message);
    } else {
      alert(message);
    }
  };

  const handleDeleteRequest = async (e) => {
    e.preventDefault();
    if (!email) return notify("Please enter your email", "error");

    const confirmDelete = window.confirm(
      `⚠️ Delete the account for "${email}"? Data will be removed in 30 days.`
    );

    if (!confirmDelete) return;

    setLoading(true);

    try {
      const res = await fetch(`https://api.veer.ng/api/v1/diver/${email}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      });

      const data = await res.json();
      if (res.ok) {
        notify(
          "Your deletion request has been submitted. Your data will be deleted in 30 days.",
          "success"
        );
        setEmail("");
      } else {
        notify(data.message || "Something went wrong", "error");
      }
    } catch (err) {
      notify("Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#12131A] text-white flex flex-col items-center justify-center px-4 py-20">
      <SEO
        title="Delete My Data - Veer"
        description="Request deletion of your personal data. Your information will be removed from our systems after 30 days."
        name="Veer - Delete My Data"
        type="website"
      />
      <h1 className="text-4xl lg:text-5xl font-bold mb-6">Delete My Data</h1>
      <p className="max-w-[600px] text-center mb-8">
        Enter your email below to request deletion of your personal data. Your
        information will be deleted from our system after 30 days.
      </p>

      <form
        onSubmit={handleDeleteRequest}
        className="flex flex-col w-full max-w-md gap-4"
      >
        <input
          type="email"
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="p-3 rounded bg-gray-800 text-black focus:outline-none"
        />

        <Button
          type="submit"
          loading={loading}
          name={`${loading ? "Submitting..." : "Request Deletion"}`}
          theme={"primary"}
          className={"mx-auto mt-5"}
        />
      </form>
    </div>
  );
};

export default Delete;
